import * as React from 'react';
import hoistStatics from 'hoist-non-react-statics';
import { DropdownMenuContext } from './types';
import { DropDownContext } from 'ui/common/dropdown-menu/dropdown-menu';

export const withDropdownMenu = <P extends DropdownMenuContext>(Component: React.ComponentType<P>): React.ComponentType<P> => {

  class ComponentWithDropdown extends React.Component<P & { wrappedComponentRef: React.LegacyRef<React.ClassAttributes<P>> }> {

    public render() {
      const { wrappedComponentRef } = this.props;

      return <DropDownContext.Consumer>
        {({ handleDropdownHide }) => (
        <Component {...this.props}
          handleDropdownHide={handleDropdownHide}
          ref={wrappedComponentRef} />
        )}
      </DropDownContext.Consumer>;
    }
  }

  return hoistStatics(ComponentWithDropdown, Component);
};
